import { useDispatch } from 'react-redux';
import { ANALYTICS_SEND_EVENT } from '@/action-types/analytics';

const useAnalytic = () => {
  const dispatch = useDispatch();

  return (eventName: string, data?: any) => dispatch({
    type: ANALYTICS_SEND_EVENT,
    eventName,
    data,
  });
};

export default useAnalytic;
